import { MUITab } from "@abb/arcadia-ui-react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { AppRegistrationGet } from "../../../models/AppRegistration"
import { useHashTab } from "../../../../hooks/useHashTab"
import { AppRegistrationDetails } from "./details_tab/AppRegistrationDetails"

const returnURL = "/app-registrations"

export function AppRegistrationContainer() {
  const { appRegistrationId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [appRegistration, setAppRegistration] = useState<AppRegistrationGet>()

  useEffect(() => {
    if (appRegistrationId) {
      digitalManagerApi
        .get<AppRegistrationGet>(`/appRegistrations/${appRegistrationId}`)
        .then((res) => {
          setAppRegistration(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [appRegistrationId, navigate])

  if (!appRegistrationId) {
    return <Navigate to={returnURL} />
  }

  if (!appRegistration) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: appRegistration.name,
    label: "Client ID",
    subtitle: appRegistration.clientId,
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
      }}
    >
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[{ id: "details", label: "Details" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />

      {activeTab === "details" && (
        <AppRegistrationDetails
          appRegistration={appRegistration}
          setAppRegistration={setAppRegistration}
        />
      )}
    </div>
  )
}
